export default "__VITE_ASSET__DrqF7Bfn__"